import React from 'react';
import bootLogo from '../../assets/beaty-boot-logo.svg';

// Full-screen brand-red boot splash. The whole viewport is BBM red so
// there's no white border or inner red square — the figure floats on
// the same color the rest of the brand uses. "Beaty Moving System"
// title sits under the logo in LemonMilk Bold (matching the sidebar
// brand mark on the desktop app).
export default function LoadingScreen() {
  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center bg-[#ed1c24]"
      // Cover any safe-area inset on iOS so the red truly bleeds edge-to-edge.
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      <img
        src={bootLogo}
        alt="Beaty Brothers Moving"
        // Capped width so the figure stays bite-sized rather than
        // dominating the screen — feels more like a respectful splash
        // than a marketing slide. Square aspect since the SVG viewBox
        // is now ~square after we tightened it to the figure bounds.
        className="w-40 h-40 sm:w-48 sm:h-48 mb-6 select-none"
        draggable={false}
      />
      <h1 className="font-lemonmilk text-white text-2xl sm:text-3xl tracking-[0.08em] uppercase mb-8 text-center px-6">
        Beaty Moving System
      </h1>
      <div className="loading-spinner-light" aria-label="Loading" role="status" />
    </div>
  );
}
